exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.swimlane {\n  padding: 2px 2px 2px 2px !important;\n}\n.swimlane-header {\n    text-align: center;\n}\n.leftmenu {\n  word-wrap: break-word;\n}\n.list-group {\n  min-height: 20px;\n}\n.list-group-item {\n  cursor: move;\n  background-color: #7fa3bb;\n}\n.list-group-item:hover {\n    background-color: #4d7590;\n}\n.list-group-item i {\n  cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2dfc4be6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ExecutiveBoardMember.vue
// module id = 0U+J
// module chunks = 1